var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"separation-line"}),_c('div',{staticClass:"love-logo"},[_c('p',[_vm._v("Made with "),_c('span',[_c('img',{attrs:{"src":require("../assets/loveLogo.svg"),"alt":"love"}})]),_vm._v(" by Susanna Saadi")])])])
}]

export { render, staticRenderFns }